import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TaskPriority } from '../tasks.types';
import { TASK_PRIORITY_STYLES } from '../tasks.utils';

/** The priority of a task as a colored badge with an arrow */
@Component({
  selector: 'app-task-priority-badge',
  templateUrl: './task-priority-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: { class: 'inline-flex' },
})
export class TaskPriorityBadgeComponent {
  @Input({ required: true }) priority!: TaskPriority;

  protected readonly styles = TASK_PRIORITY_STYLES;
}
